import React, { useState, useEffect, useRef } from 'react'
import styled from '@emotion/styled'
import { white, fontWeightRegular, fontWeightBold, fontSize3XSmall, fontFamilyOpenSans, fontSizeMedium, fontSizeSmall, fontSizeXSmall } from '../../../constants/principles'
import Dropdown from '../../generic/floatingDropdown'
import { FlexDiv, AnchorButton } from '../../generic/Basics'
import BasicButton from '../../generic/button'
import { StringUtils } from '../../../utils/siteUtils'
import Error from '../../generic/Error'
import IneligibleError from '../../generic/IneligibleError'
import { VehiclePageNumber, MILEAGE_LOW_WARNING, MILEAGE_HIGH_WARNING } from '../../../constants'
import TrimChangeModal from '../../vehicleDetails/TrimChangeModal'
import Mileage from './Mileage'
import { useScroller } from '../../../hooks'
import ConfirmationModal from '../../generic/modals/ConfirmationModal'

export default ({ yearName, makeName, modelName, vin, kbbUrl, isIneligible, isIneligibleYear, setBackToVin, submitVinCount, isDigitalRetail, isCobrandDR, isAssigned, offer, globalState, offerCode, mileageRangeValidated, ...props }) => {
  const { year, make, model, updateVehicleProp, trim, trims, mileage, updateGlobalState, isAdmin, navigatePageWithState, setShowModal, isProspectSet, experienceState, autoCheckData, vehicleTypical } = props
  const [mileageWarning, setMileageWarning] = useState('')
  const [inputMileage, setInputMileage] = useState(mileage)
  const setTrim = typeof trim === 'undefined' ? {} : trim
  const [missingTrimError, setMissingTrimError] = useState(false)
  const [mileageError, setMileageError] = useState(false)
  const { isIneligibleVehiclesEnabled, previousVehicle } = globalState
  const nextDisabled = isIneligibleVehiclesEnabled ? (setTrim && isIneligible && !isAssigned) || isIneligibleYear || (!isAssigned && inputMileage > 300000) : (setTrim && isIneligible) || inputMileage > 300000

  const showTrim = isIneligibleVehiclesEnabled
    ? vin && !props.plateStateVinError && year && make && model && ((trims && trims.length > 1) || (isIneligible && !isAssigned) || isIneligibleYear)
    : vin && !props.plateStateVinError && year && make && model && ((trims && trims.length > 1) || isIneligible)
  const [setHasScrolled, scroll] = useScroller()
  const showChangeVehicleModal = (globalState && globalState.showChangeVehicleModal) || (!isAdmin && offer && offer.canBeResubmitted)
  const isOfferCodeTcOffer = offerCode.toUpperCase() === 'TC'
  const isOfferFromServiceAppointment = offerCode.toUpperCase() === 'SL' && experienceState.lnxCode === 'ICODATSERVLANE'

  const handleMileage = newValue => {
    if (!isNaN(newValue)) {
      setInputMileage(newValue)
    }
  }
  const revertStep = () => {
    setBackToVin(true)
    updatePreviousVehicle()
  }

  useEffect(() => {
    if (vin && previousVehicle && vin !== previousVehicle.vin) {
      setInputMileage()
      updatePreviousVehicle()
    }
  }, [vin])

  const updatePreviousVehicle = () => {
    updateGlobalState({
      previousVehicle: {
        vin: vin
      }
    })
  }

  const updateTrim = trim => {
    updateVehicleProp('style', trim)
  }
  const onClickNew = e => {
    if (trim && inputMileage) {
      setMileageError(false)
      if (!mileageRangeValidated && Number(inputMileage) < autoCheckData?.miles) {
        setMileageWarning(MILEAGE_LOW_WARNING)
        updateGlobalState({ mileageRangeValidated: true })
      } else if (!mileageRangeValidated && Number(inputMileage) > autoCheckData?.miles && Number(inputMileage) > vehicleTypical?.typicalMileage * 1.2) {
        setMileageWarning(MILEAGE_HIGH_WARNING)
        updateGlobalState({ mileageRangeValidated: true })
      } else {
        updateGlobalState({ fireAnalytics: showTrim ? 'timbuybkhome_selltrade_styleselect' : 'timbuybkhome_selltrade_mileageselect', submitVinCount: submitVinCount + 1 })
        navigatePageWithState({ m: parseInt(inputMileage), p: VehiclePageNumber, lp: VehiclePageNumber })
      }
    }
    if (!trim) {
      setMissingTrimError(true)
      updateGlobalState({ fireAnalytics: 'timbuybkhome_selltrade_styleselect_error' })
    }
    if (!inputMileage) {
      setMileageError(true)
      updateGlobalState({ fireAnalytics: showTrim ? 'timbuybkhome_selltrade_styleselect_error' : 'timbuybkhome_selltrade_mileageselect_error' })
    }
  }
  const confirmClose = () => {
    setShowModal(false)
  }
  const confirmContinue = () => {
    updateGlobalState({ showChangeVehicleModal: showChangeVehicleModal })
    setShowModal(false)
    setBackToVin(true)
  }
  useEffect(() => {
    setHasScrolled(true)
    scroll('body', 'top')
  }, [])
  return (
    year &&
    make &&
    model && (
      <>
        <FullWidthFlexDiv>
          <StyledH2>
            {yearName} {StringUtils.upperCaseFirstLetter(makeName)} {StringUtils.upperCaseFirstLetter(modelName)}
            {!showTrim && (
              <>
                <br />
                {trim && trim.displayName}
              </>
            )}
          </StyledH2>
          {vin && <StyledDivInfo>VIN: {vin}</StyledDivInfo>}
        </FullWidthFlexDiv>
        {showTrim && (
          <FullWidthFlexDiv padding={(setTrim && isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true)) || isIneligibleYear ? 0 : 20}>
            <Dropdown
              testId={'bi-dr-ymm-style'}
              id={'trim'}
              fullWidth={true}
              label="Style"
              backgroundColor={white}
              options={trims}
              onChange={e => (isProspectSet && trim ? setShowModal(e.target.value) : updateTrim(e.target.value))}
              valueProp={'trimId'}
              currentValue={trim}
              isError={(!trim && missingTrimError) || (trim && isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true)) || isIneligibleYear}
            />
            {setTrim && <IneligibleError isError={(isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true)) || isIneligibleYear} {...{ vin, year, make, model, trim, isAdmin, kbbUrl, isDigitalRetail, isCobrandDR, isOfferCodeTcOffer }} />}
            {<Error isError={missingTrimError && !trim} id={'trim-error'} text={'Please select a style.'} />}
          </FullWidthFlexDiv>
        )}
        {(!(setTrim && isIneligible) || (isIneligibleVehiclesEnabled ? isAssigned && !isIneligibleYear : false)) && (
          <FullWidthFlexDiv>
            <Mileage
              mileageWarning={mileageWarning}
              handleMileage={handleMileage}
              inputMileage={inputMileage}
              isError={mileageError}
              {...{ mileage, kbbUrl, isDigitalRetail, isCobrandDR, vin, isAssigned, offerCode, isIneligibleVehiclesEnabled }}
              {...props}
            />
          </FullWidthFlexDiv>
        )}
        {!nextDisabled && (
          <StyledButton data-testid={'bi-btn-get-started'} isSelected={true} onClick={onClickNew}>
            Get Started
          </StyledButton>
        )}
        {!isOfferFromServiceAppointment && (
          <ResetButton data-testid={'bi-btn-change-vehicle'} onClick={() => (showChangeVehicleModal ? setShowModal('Change vehicle') : revertStep())}>
            Change Vehicle
          </ResetButton>
        )}
        <TrimChangeModal changeTrim={props.changeTrim} setShowModal={setShowModal} showModal={trims && trims.some(trim => trim.trimId === +props.showModal) && props.showModal} trims={trims} trim={trim} updateGlobalState={updateGlobalState} />
        <ConfirmationModal testId={`vc-change-vehicle`} modalName={`Change vehicle`} title="Change Vehicle" confirmText="Continue" cancelText="Close" onConfirmSelected={confirmContinue} onCancelSelected={confirmClose}>
          <ContentGroup>All previous equipment and condition selections will be removed.</ContentGroup>
        </ConfirmationModal>
      </>
    )
  )
}

const ContentGroup = styled.div`
  display: flex;
  flex-basis: 60px;
  flex-direction: column;
  div {
    margin-top: 4px;
  }
`
const FullWidthFlexDiv = styled(FlexDiv)`
  width: 100%;
  ${p => p.padding && `padding-bottom:${p.padding}px`}
`
const ResetButton = styled(AnchorButton)`
  padding-top: 8px;
`
const StyledDivInfo = styled.div`
  text-align: center;
  font-weight: ${fontWeightRegular};
  font-size: ${fontSize3XSmall};
  font-family: ${fontFamilyOpenSans};
  margin-bottom: 16px;
  width: 99%;
`
const StyledH2 = styled.h2`
  text-align: center;
  line-height: 26px;
  margin: 16px 0px;
  font-size: ${fontSizeMedium};
  font-weight: ${fontWeightBold};
  font-family: ${fontFamilyOpenSans};
  width: 100%;
`
const StyledButton = styled(BasicButton)`
  width: 100%;
  margin-top: 16px;
  font-size: ${p => (p.isSelected ? fontSizeSmall : fontSizeXSmall)};
  line-height: 26px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
`
